import { LoginButton } from "../../components/LoginButton";
import React from "react";
import { motion } from "framer-motion";
import dynamic from "next/dynamic";

const World = dynamic(() => import("../../components/UI/globe").then(m => m.World), {
    ssr: false
});

const LoginPage = () => {
    const globeConfig = {
        pointSize: 4,
        globeColor: "#00738A",
        showAtmosphere: true,
        atmosphereColor: "#004A8F",
        atmosphereAltitude: 0.1,
        emissive: "#062056",
        emissiveIntensity: 0.1,
        shininess: 0.9,
        polygonColor: "rgba(255,255,255,0.7)",
        ambientLight: "#38bdf8",
        directionalLeftLight: "#ffffff",
        directionalTopLight: "#ffffff",
        pointLight: "#ffffff",
        arcTime: 1500,
        arcLength: 0.9,
        rings: 1,
        maxRings: 3,
        initialPosition: { lat: 51.0, lng: -0.6164908012255877 },
        autoRotate: true,
        autoRotateSpeed: 0.1
    };
    const sampleArcs = [
        {
            order: 1,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -22.9068,
            endLng: -43.1729,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 1,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 3.139,
            endLng: 101.6869,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 1,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -1.303396,
            endLng: 36.852443,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 2,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 35.6762,
            endLng: 139.6503,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 2,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 3.139,
            endLng: 101.6869,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 2,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 36.162809,
            endLng: -115.119411,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 3,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 22.3193,
            endLng: 114.1694,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 3,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 40.7128,
            endLng: -74.006,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 3,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 51.5072,
            endLng: -0.1276,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 4,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -15.595412,
            endLng: -56.05918,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 4,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 22.3193,
            endLng: 114.1694,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 4,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 48.8566,
            endLng: -2.3522,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 5,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 51.5072,
            endLng: -0.1276,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 5,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -33.8688,
            endLng: 151.2093,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 5,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 48.8566,
            endLng: -2.3522,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 6,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 1.094136,
            endLng: -63.34546,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 6,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 35.6762,
            endLng: 139.6503,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 6,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 51.5072,
            endLng: -0.1276,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 7,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -15.595412,
            endLng: -56.05918,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 7,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 52.52,
            endLng: 13.405,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 7,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 34.0522,
            endLng: -118.2437,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 8,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -33.936138,
            endLng: 18.436529,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 8,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 52.3676,
            endLng: 4.9041,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 8,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 40.7128,
            endLng: -74.006,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 9,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 34.0522,
            endLng: -118.2437,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 9,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -22.9068,
            endLng: -43.1729,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 9,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -34.6037,
            endLng: -58.3816,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 10,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 28.6139,
            endLng: 77.209,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 10,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 31.2304,
            endLng: 121.4737,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 10,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 52.3676,
            endLng: 4.9041,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 11,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 34.0522,
            endLng: -118.2437,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 11,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 31.2304,
            endLng: 121.4737,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 11,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 1.3521,
            endLng: 103.8198,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 12,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 37.7749,
            endLng: -122.4194,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 12,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 22.3193,
            endLng: 114.1694,
            arcAlt: 0.2,
            color: "#F09006"
        },
        {
            order: 12,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 34.0522,
            endLng: -118.2437,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 13,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 22.3193,
            endLng: 114.1694,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 13,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 35.6762,
            endLng: 139.6503,
            arcAlt: 0.3,
            color: "#F09006"
        },
        {
            order: 13,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: -34.6037,
            endLng: -58.3816,
            arcAlt: 0.1,
            color: "#F09006"
        },
        {
            order: 14,
            startLat: 51.24206267018193,
            startLng: -0.6164908012255877,
            endLat: 21.395643,
            endLng: 39.883798,
            arcAlt: 0.3,
            color: "#F09006"
        }
    ];
    return (
        <div className="flex flex-row items-center justify-center py-4 h-full bg-sstl-light-grey relative w-full">
            <div className="max-w-8xl mx-auto w-full relative overflow-hidden h-full px-4">
                <motion.div
                    initial={{
                        opacity: 0,
                        y: 20
                    }}
                    animate={{
                        opacity: 1,
                        y: 0
                    }}
                    transition={{
                        duration: 1
                    }}
                    className="div h-full flex flex-col flex-grow relative items-center"
                >
                    <h1 className="text-center text-5xl font-normal tracking-wider text-sstl-dark mt-2">SIMBA</h1>
                    <p className="text-center text-2xl font-normal tracking-wider text-sstl-blue max-w-md mt-2 mx-auto">Your AI Assistant</p>
                </motion.div>
                <div className="absolute inset-0 flex items-center justify-center z-20">
                    <LoginButton />
                </div>
                <div className="absolute w-full -bottom-20 h-full z-10 left-0">
                    <World data={sampleArcs} globeConfig={globeConfig} />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
